import React, { useContext, useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core';
import { Close, InfoOutlined } from '@material-ui/icons';
import { IconButton, Message } from 'components';
import { UserSessionValuesContext } from 'contexts';

const useStyles = makeStyles(() => ({
  alertBanner: {
    zIndex: 3,
  },
}));

const AlertBanner = ({ alertBannerRef, ...props }) => {
  const { alertMessage } = useContext(UserSessionValuesContext);
  const [showAlertBanner, setShowAlertBanner] = useState(Boolean(alertMessage));

  const classes = useStyles();

  useEffect(() => setShowAlertBanner(Boolean(alertMessage)), [alertMessage]);

  if (!showAlertBanner) {
    return '';
  }

  return (
    <Message
      action={
        <IconButton
          aria-label="close"
          onClick={() => setShowAlertBanner(false)}
        >
          <Close />
        </IconButton>
      }
      className={classes.alertBanner}
      icon={<InfoOutlined />}
      messageRef={alertBannerRef}
      text={alertMessage}
      {...props}
    />
  );
};

export default AlertBanner;
